import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Button from 'components/common/Button/Button'
import Mixin from 'components/common/Mixin'
import Link from 'components/common/Link/Link'
import UpdatingBlock from 'components/common/UpdatingBlock/UpdatingBlock'
import NestedReviewsSchema from 'components/common/NestedReviewsSchema/NestedReviewsSchema'
import { formatSurveyDate } from './helpers'
import ReviewBlock from './ReviewBlock'

const TrumpetRatings = ({
  loading,
  hasReviews,
  setWrapperRef,
  reviewsData,
  handlePrevClick,
  handleNextClick,
  itemReviewed,
  nestedReviews,
  showPrev,
  showNext,
  writeReviewURL
}) =>
  <Wrapper ref={ setWrapperRef }>
    <NestedReviewsSchema itemReviewed={ itemReviewed } nestedReviews={ nestedReviews } />
    <UpdatingBlock condition={ loading }>
      {
        hasReviews ?
          <ReviewsBlock>
            {
              reviewsData.map(({ SurveyDate, ...reviewData }, index) =>
                <ReviewBlock key={ index } formattedDate={ formatSurveyDate(SurveyDate) } { ...reviewData } />)
            }
            <Pagination>
              {
                showPrev &&
                <PrevButton link onClick={ handlePrevClick }>Prev</PrevButton>
              }
              {
                showNext &&
                <NextButton link onClick={ handleNextClick }>Next</NextButton>
              }
            </Pagination>
          </ReviewsBlock> :
          <NoReviewsBlock>
            <NoReviewTitle>There are no reviews for this store yet</NoReviewTitle>
            <WriteReviewBtn data-at-store-writereview button to={ writeReviewURL } target="_blank" rel="noopener noreferrer">
              Write a Review
            </WriteReviewBtn>
          </NoReviewsBlock>
      }
    </UpdatingBlock>
  </Wrapper>

export default TrumpetRatings

TrumpetRatings.propTypes = {
  handleNextClick: PropTypes.func,
  handlePrevClick: PropTypes.func,
  hasReviews: PropTypes.bool,
  itemReviewed: PropTypes.shape(),
  loading: PropTypes.bool,
  nestedReviews: PropTypes.arrayOf(PropTypes.shape()),
  reviewsData: PropTypes.arrayOf(PropTypes.shape()),
  setWrapperRef: PropTypes.func,
  showNext: PropTypes.bool,
  showPrev: PropTypes.bool,
  writeReviewURL: PropTypes.string
}

const Wrapper = styled.div`
  position: relative;
  min-height: 300px;
`

const ReviewsBlock = styled.div`
  font-size: 14px;
  line-height: 1.42857143;
`

const NoReviewsBlock = styled.div`
  text-align: center;
  margin-top: 20px;
`

const Pagination = styled.div`
  width: 100%;
  margin: 10px 0 0;
`

const PaginationButton = styled(Button)`
  && {
    padding: 0;
    color: #37556e;
    cursor: pointer;

    &:hover,
    &:focus,
    &:active {
      box-shadow: 0 0 4px 0 rgba(0, 141, 220, 0.56);
    }
  }
`

const PrevButton = styled(PaginationButton)`
  float: left;
`

const NextButton = styled(PaginationButton)`
  float: right;
`

const NoReviewTitle = styled.h1`
  ${Mixin.font.GothamBold(20, 600)}
  ${Mixin.responsive('font-size', '18px', '16px')}
  text-transform: uppercase;
`

const WriteReviewBtn = styled(Link)`
  display: inline-block;
  margin: 15px;
`

